module.exports = __webpack_public_path__ + "img/pci.df29bf2d.svg";